import { useEffect, useState } from "react";
import api, { ROLE_LABELS, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Trash2, UserPlus } from "lucide-react";

export default function UsersPage() {
  const [users, setUsers] = useState([]);
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ email: "", password: "", name: "", role: "magazziniere" });

  const load = async () => {
    const { data } = await api.get("/users");
    setUsers(data);
  };

  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/users", form);
      toast.success("Utente creato");
      setCreating(false);
      setForm({ email: "", password: "", name: "", role: "magazziniere" });
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  const onDelete = async (id) => {
    if (!window.confirm("Eliminare questo utente?")) return;
    try { await api.delete(`/users/${id}`); toast.success("Eliminato"); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div className="p-4 md:p-8 max-w-5xl mx-auto">
      <div className="flex items-end justify-between mb-6 flex-wrap gap-3">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-2">Amministrazione</div>
          <h1 className="font-display text-4xl font-black uppercase tracking-tight">Utenti</h1>
        </div>
        <button onClick={()=>setCreating(!creating)} className="gm-btn-primary h-11 px-5 rounded-sm flex items-center gap-2" data-testid="users-new-button">
          <UserPlus size={16} /> Nuovo utente
        </button>
      </div>

      {creating && (
        <form onSubmit={submit} className="gm-card p-5 mb-5 grid grid-cols-1 md:grid-cols-4 gap-3">
          <input required placeholder="Nome" value={form.name} onChange={e=>setForm(s=>({...s, name: e.target.value}))} className="gm-input" data-testid="user-name-input" />
          <input required type="email" placeholder="Email" value={form.email} onChange={e=>setForm(s=>({...s, email: e.target.value}))} className="gm-input" data-testid="user-email-input" />
          <input required type="password" placeholder="Password" value={form.password} onChange={e=>setForm(s=>({...s, password: e.target.value}))} className="gm-input" data-testid="user-password-input" />
          <select value={form.role} onChange={e=>setForm(s=>({...s, role: e.target.value}))} className="gm-input" data-testid="user-role-select">
            {Object.entries(ROLE_LABELS).map(([k,v])=><option key={k} value={k}>{v}</option>)}
          </select>
          <div className="md:col-span-4">
            <button type="submit" className="gm-btn-primary h-11 px-5 rounded-sm" data-testid="user-create-submit">Crea utente</button>
          </div>
        </form>
      )}

      <div className="gm-card overflow-x-auto">
        <table className="gm-table">
          <thead>
            <tr><th>Nome</th><th>Email</th><th>Ruolo</th><th></th></tr>
          </thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id}>
                <td className="font-semibold">{u.name}</td>
                <td className="font-mono-data text-sm text-zinc-300">{u.email}</td>
                <td><span className="gm-badge gm-badge-muted">{ROLE_LABELS[u.role]}</span></td>
                <td className="text-right">
                  <button onClick={()=>onDelete(u.id)} className="text-[#FF3B30] hover:bg-[#FF3B30]/10 p-2"><Trash2 size={16} /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
